// Payments MFE entry point
import { createApp } from 'vue';
import { setupApp } from '@Src/app/setupApp';
import { AppContext } from 'host/enums';
import { setMfeContext } from 'host/mfeBridge';
import type { Company, Brand } from '@Shared';
import App from './App.vue';
import { syncRouterToHost } from '@Router/syncRouterToHost';
import router from '@Router/index';

// Import stores
import { useCompanyStore } from '@Stores/company.store';


let app: ReturnType<typeof createApp> | null = null;
let containerId: string | null = null;

export const mount = async (appContainerId: string,  options?: {company: Company, brand?: Brand | null, brokerageDetectionEnabled?: boolean}) => {
    
    if (app) {
        console.warn('[Request MFE] App already exists. Forcing unmount...');
        app.unmount();
    }

    containerId = appContainerId;
    setMfeContext(AppContext.Request);

    app = createApp(App);
    await setupApp(app);

    if (options.company) {
        const companyStore = useCompanyStore();
        companyStore.setCompany(options.company);
        companyStore.setBrand(options.brand ?? null);
        companyStore.setBrokerageDetectionEnabled(options.brokerageDetectionEnabled ?? false);
    }

    await syncRouterToHost(router);

    app.mount(containerId);
};

export const unmount = () => {
    if (!app) return;
    app.unmount();

    if (containerId) {
        const container = document.querySelector(containerId);
        if (container) container.innerHTML = '';
    }
    app = null;
};
